<template>
  <section class="qilin-evolution" aria-labelledby="qilin-evolution-title">
    <div class="qilin-evolution__heading">
      <div>
        <small>เส้นทางการเติบโต</small>
        <h2 id="qilin-evolution-title">เส้นทางวิวัฒนาการของคู่หู</h2>
      </div>
      <span>ปลดล็อกทุก 5 เลเวล</span>
    </div>

    <div class="qilin-evolution__rail" role="list" aria-label="ร่างคู่หูและระดับที่ปลดล็อก">
      <article
        v-for="form in forms"
        :key="form.stage"
        class="qilin-evolution__card"
        :class="{
          'qilin-evolution__card--current': form.current,
          'qilin-evolution__card--locked': form.locked
        }"
        role="listitem"
      >
        <div class="qilin-evolution__visual">
          <img :src="form.image" :alt="`คู่หูร่างที่ ${form.stage}`" width="180" height="180">
          <span v-if="form.locked" class="qilin-evolution__lock" aria-hidden="true">🔒</span>
          <span v-else-if="!form.current" class="qilin-evolution__check" aria-hidden="true">✓</span>
        </div>
        <strong>ร่างที่ {{ form.stage }}</strong>
        <small v-if="form.current" class="qilin-evolution__status qilin-evolution__status--current">ร่างปัจจุบัน</small>
        <small v-else-if="form.locked" class="qilin-evolution__status">เลเวล {{ form.unlockLevel }}</small>
        <small v-else class="qilin-evolution__status qilin-evolution__status--unlocked">ปลดล็อกแล้ว</small>
      </article>
    </div>
  </section>
</template>

<script>
import { qilinStageImage } from '../../config/qilinAssets'
import { QILIN_PROGRESSION_CONFIG } from '../../services/qilinProgression'

export default {
  name: 'QilinEvolutionGallery',
  props: {
    pet: { type: Object, required: true }
  },
  computed: {
    forms () {
      const currentLevel = Math.max(1, Number(this.pet.level) || 1)
      const currentStage = Math.max(1, Math.min(QILIN_PROGRESSION_CONFIG.maxStage, Number(this.pet.stage) || 1))
      return Array.from({ length: QILIN_PROGRESSION_CONFIG.maxStage }, (_, index) => {
        const stage = index + 1
        const unlockLevel = (stage - 1) * QILIN_PROGRESSION_CONFIG.levelsPerStage + 1
        return {
          stage,
          unlockLevel,
          current: stage === currentStage,
          locked: currentLevel < unlockLevel,
          image: qilinStageImage(stage, this.pet.gender)
        }
      })
    }
  }
}
</script>

<style scoped>
.qilin-evolution {
  margin-top: 18px;
  padding: 20px;
  border: 1px solid rgba(255, 218, 112, .2);
  border-radius: 25px;
  background: linear-gradient(145deg, #0d183f, #060821 72%);
  color: #fff;
}
.qilin-evolution__heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 15px;
}
.qilin-evolution__heading small {
  color: #67dbbd;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: .08em;
}
.qilin-evolution__heading h2 { margin: 3px 0 0; font-size: 20px; }
.qilin-evolution__heading > span {
  padding: 6px 10px;
  border: 1px solid rgba(255, 218, 112, .2);
  border-radius: 999px;
  background: rgba(251, 200, 68, .07);
  color: #ffe287;
  font-size: 11px;
  white-space: nowrap;
}
.qilin-evolution__rail {
  display: grid;
  grid-template-columns: repeat(7, minmax(110px, 1fr));
  gap: 9px;
  overflow-x: auto;
  padding: 2px 1px 7px;
  scrollbar-color: rgba(103, 219, 189, .45) transparent;
  scrollbar-width: thin;
}
.qilin-evolution__card {
  position: relative;
  min-width: 110px;
  padding: 8px 7px 10px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, .1);
  border-radius: 16px;
  background: rgba(255, 255, 255, .045);
  text-align: center;
}
.qilin-evolution__card--current {
  border-color: rgba(255, 210, 91, .72);
  background: linear-gradient(155deg, rgba(251, 200, 68, .18), rgba(103, 219, 189, .08));
  box-shadow: inset 0 0 0 1px rgba(255, 235, 160, .09), 0 8px 22px rgba(251, 200, 68, .08);
}
.qilin-evolution__visual {
  position: relative;
  display: grid;
  height: 90px;
  place-items: center;
}
.qilin-evolution__visual img {
  width: 86px;
  height: 86px;
  object-fit: contain;
  filter: drop-shadow(0 8px 10px rgba(0, 0, 0, .34));
}
.qilin-evolution__card--locked .qilin-evolution__visual img {
  opacity: .62;
  filter: grayscale(1) brightness(.25) contrast(1.25) drop-shadow(0 6px 9px rgba(0, 0, 0, .5));
}
.qilin-evolution__lock,
.qilin-evolution__check {
  position: absolute;
  right: 1px;
  bottom: 1px;
  display: grid;
  width: 25px;
  height: 25px;
  place-items: center;
  border-radius: 50%;
  background: rgba(3, 5, 27, .86);
  font-size: 12px;
}
.qilin-evolution__check { color: #6ce1c1; font-weight: 900; }
.qilin-evolution__card > strong { display: block; margin-top: 3px; font-size: 13px; }
.qilin-evolution__status { display: block; margin-top: 2px; color: rgba(255, 255, 255, .5); font-size: 10px; }
.qilin-evolution__status--current { color: #ffe17b; font-weight: 800; }
.qilin-evolution__status--unlocked { color: #78e7c9; }
@media (max-width: 767px) {
  .qilin-evolution { padding: 17px 14px; border-radius: 22px; }
  .qilin-evolution__heading { align-items: flex-start; flex-direction: column; gap: 8px; }
  .qilin-evolution__heading h2 { font-size: 18px; }
  .qilin-evolution__rail { grid-template-columns: repeat(7, 104px); margin-right: -14px; padding-right: 14px; }
  .qilin-evolution__card { min-width: 104px; }
}
</style>
